import styled from 'styled-components';

const Tag = styled.div`
  background-color: ${({ theme }) => theme.colors.primary.c200};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.neutrals.black};
  padding: 0.1rem 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.fontSize.xxs};
  color: ${({ theme }) => theme.colors.neutrals.black}};
  line-height: ${({ theme }) => theme.lineHeight.xs};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  width: fit-content;
  height: fit-content;
  font-family: Inter;
`;

export default Tag;
